import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "estate-listing__item" }
const _hoisted_2 = { class: "estate-card estate-card--rating" }
const _hoisted_3 = { class: "estate-card__header" }
const _hoisted_4 = { class: "estate-card__photos" }
const _hoisted_5 = { class: "estate-card__info" }
const _hoisted_6 = { class: "estate-card__title" }
const _hoisted_7 = { class: "estate-card__address" }
const _hoisted_8 = { class: "estate-card__footer" }
const _hoisted_9 = { class: "estate-card__rating-text" }
const _hoisted_10 = { class: "estate-card__author" }
const _hoisted_11 = { class: "estate-card__date" }
const _hoisted_12 = { class: "estate-card__author-name" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AdListGallery = _resolveComponent("AdListGallery")!
  const _component_EstateAgentReviewStars = _resolveComponent("EstateAgentReviewStars")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_AdListGallery, {
            images: _ctx.review.images,
            adGuid: _ctx.review.adGuid,
            estateType: _ctx.review.estateType,
            estateSubType: _ctx.review.estateSubType,
            imageLimitCount: 1,
            width: 150,
            height: 120
          }, null, 8, ["images", "adGuid", "estateType", "estateSubType"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_EstateAgentReviewStars, {
            rating: _ctx.review.rating
          }, null, 8, ["rating"]),
          _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.review.title), 1),
          _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.address), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          (_ctx.review.review)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createTextVNode(_toDisplayString(_ctx.review.review), 1)
              ], 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createTextVNode(_toDisplayString(_ctx.$t('EstateAgentReviewStarsListItem.empty-review')), 1)
              ], 64))
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.$filters.date(_ctx.review.reviewDate)), 1),
          _createTextVNode(),
          _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.review.userName), 1)
        ])
      ])
    ])
  ]))
}